import { Button, ButtonSizes } from "@certa/catalyst/components/Button";
import { Tooltip, TooltipVariants } from "@certa/catalyst/components/Tooltip";
import { Sort as SortIcon } from "@certa/icons/components/Sort";
import { useIntl } from "react-intl";
import { useState } from "react";

const BUFFER_WIDTH = 100;
const BUFFER_HEIGHT = 30;

type FitWidthHeightToggleProps = {
  pdfContainerParentRef: React.RefObject<HTMLDivElement>;
  handleScaleChange: (scale: number) => void;
  initialPageSize?: {
    width: number;
    height: number;
  };
};

export const FitWidthHeightToggle = ({
  pdfContainerParentRef,
  handleScaleChange,
  initialPageSize
}: FitWidthHeightToggleProps) => {
  const [isFitWidth, setIsFitWidth] = useState(false);

  const intl = useIntl();

  const handleToggle = () => {
    const clientWidth = pdfContainerParentRef.current?.clientWidth;
    const clientHeight = pdfContainerParentRef.current?.clientHeight;

    if (clientHeight && clientWidth && initialPageSize) {
      if (isFitWidth) {
        const heightScale =
          (clientHeight - BUFFER_HEIGHT) / initialPageSize.height;
        handleScaleChange(Number(heightScale.toFixed(2)));
      } else {
        const widthScale = (clientWidth - BUFFER_WIDTH) / initialPageSize.width;
        handleScaleChange(Number(widthScale.toFixed(2)));
      }
    }
    setIsFitWidth(!isFitWidth);
  };

  const fitToWidth = intl.formatMessage({
    id: "common.fitToWidth",
    defaultMessage: "Fit to width"
  });

  const fitToHeight = intl.formatMessage({
    id: "common.fitToHeight",
    defaultMessage: "Fit to height"
  });

  return (
    <Tooltip
      content={isFitWidth ? fitToHeight : fitToWidth}
      variant={TooltipVariants.LIGHT}
    >
      <Button
        onClick={handleToggle}
        size={ButtonSizes.SMALL}
        disabled={!initialPageSize}
      >
        <SortIcon
          size={18}
          svgProps={{
            style: {
              transform: `rotate(${isFitWidth ? 0 : 90}deg)`
            }
          }}
        />
      </Button>
    </Tooltip>
  );
};
